import { render, staticRenderFns } from "./addSmallClass.vue?vue&type=template&id=3bfbc825&scoped=true&"
import script from "./addSmallClass.vue?vue&type=script&lang=js&"
export * from "./addSmallClass.vue?vue&type=script&lang=js&"
import style0 from "./addSmallClass.vue?vue&type=style&index=0&id=3bfbc825&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfbc825",
  null
  
)

export default component.exports